export default [
  {
    name: 'USPS First Class Mail',
    value: 'usps_first_class_mail',
    carrier: 'stamps_com',
  },
  {
    name: 'USPS Priority Mail',
    value: 'usps_priority_mail',
    carrier: 'stamps_com',
  },
  {
    name: 'USPS Priority Mail Express',
    value: 'usps_priority_mail_express',
    carrier: 'stamps_com',
  },
  {
    name: 'FedEx Standard Overnight®',
    value: 'fedex_standard_overnight',
    carrier: 'fedex',
  },
  {
    name: 'FedEx 2Day®',
    value: 'fedex_2day',
    carrier: 'fedex',
  },
  {
    name: 'FedEx Express Saver®',
    value: 'fedex_express_saver',
    carrier: 'fedex',
  },
];

export const shippingInvoiceParamList = [
  'zip_code',
  'phones_count',
  'shipping_service',
  'sims_count',
  'price',
];
